import { MemoryStorage, AppStates, AppEvents, logService } from '@Engage.Core';
import { Http, serverTime, getVersion, eventsService } from '@Engage.Core';
import { DefaultResponseErrorMessage, StorageKeys } from '@Engage.Data.Constants';
import { ResponseError } from '@Engage.Data.Models';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import { localStorageService } from '../storage/localStorage/LocalStorageService';
// import { AppOptions } from '@Application.Modules/Index';
export const base64url = function (source) {
    let encodedSource = Base64.stringify(source);
    encodedSource = encodedSource.replace(/=+$/, '');
    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');
    return encodedSource;
};
class HttpServiceClass {
    constructor() {
        this.http = new Http();
        this.JWT_TOKEN = this.generateJWTToken();
    }
    get(url, payload, options) {
        return this.call('get', url, payload, options);
    }
    post(url, payload, options) {
        return this.call('post', url, payload, options);
    }
    call(method, url, payload, options = {}) {
        let headers = !options.externalCall ? this.shapeHeaders(options) : {};
        options.headers = Object.assign({}, headers, options.headers);
        let appOptions = MemoryStorage.get(AppStates.AppOptions);
        this.API_PATH = appOptions.get(AppStates.ApiUrl) + 'api/';
        return this.http[method](this.API_PATH + url, payload, options)
            .catch((error) => {
            eventsService.dispatch(AppEvents.LoadError, JSON.stringify(error));
            let errorResponse = this.mapErrorResponse(error);
            if (errorResponse.ErrorMessage === 'The token is expired') {
                this.JWT_TOKEN = this.generateJWTToken();
                options.headers['Authorization'] = this.JWT_TOKEN;
                return this.http[method](this.API_PATH + url, payload, options) // resend request
                    .catch((error) => {
                    let errorResponse = this.mapErrorResponse(error);
                    return Promise.reject(errorResponse);
                });
            }
            else {
                return Promise.reject(errorResponse);
            }
        });
    }
    shapeHeaders(options) {
        let appOptions = MemoryStorage.get(AppStates.AppOptions);
        let autoQA = false;
        try {
            autoQA = !!JSON.parse(localStorageService.get(StorageKeys.AutoQA, { isSecureValue: false, expandKey: false }));
        }
        catch (e) {
        }
        let headerObject = {
            'X-SiteCode': appOptions.get(AppStates.SiteCode),
            'X-ConfigCode': appOptions.get(AppStates.ConfigCode),
            'X-ClientCode': appOptions.get(AppStates.ClientCode),
            'Access-Control-Allow-Origin': '*',
            'X-Environment': appOptions.get(AppStates.Environment),
            'settingsKey': appOptions.get(AppStates.SettingsKey),
            'Version': getVersion(),
            'Source-System': 'Plugin',
            'Authorization': this.JWT_TOKEN,
            'Location': options.location,
            'AutoQA': autoQA,
            // 'SSID': AppOptions.getSessionId()
        };
        let attr = appOptions.get(AppStates.Attr);
        if (attr) {
            headerObject['X-Attribute'] = attr;
        }
        let productCode = appOptions.get(AppStates.ProductCode);
        if (productCode) {
            headerObject['Product-Code'] = productCode;
        }
        let paperCode = appOptions.get(AppStates.PaperCode);
        if (paperCode) {
            headerObject['Paper-Code'] = paperCode;
        }
        let G2IUserData = MemoryStorage.get(AppStates.G2IUserData);
        if (G2IUserData) {
            const g2iDataHeader = JSON.stringify(G2IUserData);
            // TODO: check max size and change aproach if > 1kb
            if (g2iDataHeader.length > 1024) {
                logService.warn('X-G2IData length', g2iDataHeader.length);
            }
            headerObject['X-G2IData'] = g2iDataHeader;
        }
        return headerObject;
    }
    generateJWTToken() {
        const JWTExpirationTime = 20000 * 60 * 60; // 4 hours
        const xyze = "db3OIsj+BXE9NZDy0t8W3TcNekrF+2d/1sFnWG4HnV8TZY30iTOdtVWJG8abWvB1GlOgJuQZdcF2Luqm/hccMw==";
        const header = {
            "alg": "HS256",
            "typ": "JWT"
        };
        const data = {
            "unique_name": "ConneXt",
            "exp": Math.round(serverTime.get().valueOf() / 1000) + JWTExpirationTime
        };
        let stringifiedHeader = Utf8.parse(JSON.stringify(header)), stringifiedData = Utf8.parse(JSON.stringify(data)), encodedHeader = base64url(stringifiedHeader), encodedData = base64url(stringifiedData), signature = encodedHeader + "." + encodedData, newSignature;
        newSignature = HmacSHA256(signature, xyze);
        signature = base64url(newSignature);
        return 'Bearer ' + encodedHeader + '.' + encodedData + '.' + signature;
    }
    mapErrorResponse(errorResponse) {
        let result = new ResponseError();
        let responseText = typeof errorResponse === 'string' ? errorResponse : errorResponse.Message;
        result.ErrorMessage = DefaultResponseErrorMessage;
        result.ErrorCode = '';
        let responseData;
        try {
            responseData = JSON.parse(responseText);
        }
        catch (ex) {
            return result;
        }
        if (!responseData || !responseData.Errors) {
            result.ErrorMessage = responseData.Message || result.ErrorMessage;
            return result;
        }
        if (Array.isArray(responseData.Errors)) {
            result.ErrorMessage = '';
            responseData.Errors.forEach(function (msg) {
                if (typeof msg === 'string') {
                    result.ErrorMessage += msg + ' ';
                }
                else {
                    result.ErrorMessage += msg.Message + ' ';
                }
            });
        }
        result.ErrorCode = responseData.ErrorCode || errorResponse.ErrorCode || '';
        return result;
    }
}
export const HttpService = new HttpServiceClass();
